import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { ConsultaPrestamosService } from 'src/app/services/consulta-prestamos/consulta-prestamos.service';
import { environment } from '../../../environments/environment';
import { DialogTipoRechazoPrestamo } from '../../components/prestamos/prestamos-rechazar.component';
import { NgForm } from '@angular/forms';
import { PrestamosService } from 'src/app/services/prestamos/prestamos.service';


export interface DialogData
{
    archivos: any
    idPostulacion: any
    montoSolicitado: any
    rutUsuario: any
    nombreUsuario: any
    apellidoUsuario: any    
    rol:any
    recarga:any
    cantidadCuotas:any
    idCodeudor1:any
    idCodeudor2:any
    idPrestamo:any
    tipoPrestamo:any
    idTipoPrestamo:any
    montoCuota:any
    fechaPrimerPago:any
    deshabilitado:boolean
    presionaEditar:boolean
    mostrarEditar:any
    disponiblePago:any
    idCantidadCuota: any,
    mostrarAprobarButton:any
    rutCodeudor1:any
    nombreCodeudor1:any
    apellidoCodeudor1: any
    rutCodeudor2:any
    nombreCodeudor2:any
    apellidoCodeudor2: any
    totalMaximo:any
    idUsuario:any
    tipos:any
    cuotas:any
    planes:any
    calcula:any
    asientoContable:any
    montoTotalCuota: any
    estado: any
}

@Component({
    selector: 'dialog-overview-prestamo-ejecutivo-dialog',
    templateUrl: '../../pages/prestamos/prestamos-confirmar.html',
    styleUrls: ['../../pages/prestamos/prestamos.component.css']
})
export class DialogEditPrestamoEjecutivo
{   
    rol:string = localStorage.getItem("rol")
    prestamo: any = {montoSolicitado:this.data.montoSolicitado,
            cantidadCuotas:this.data.cantidadCuotas,
            idCantidadCuotas:this.data.idCantidadCuota,
            idUsuario: '',
            idAfiliado:this.data.idUsuario,
            idCodeudor1:this.data.idCodeudor1,
            idCodeudor2:this.data.idCodeudor2,
            tipoPrestamo:this.data.tipoPrestamo,
            nombreSolicitante:this.data.nombreUsuario, 
            apellidoSolicitante:this.data.apellidoUsuario, 
            idPostulacion:this.data.idPostulacion,
            fechaPrimerPago:this.data.fechaPrimerPago,
            montoCuota:this.data.montoCuota,
            tipos:this.data.tipos, 
            cuotas: this.data.cuotas,
            totalMaximo :this.data.totalMaximo,
            idPrestamo: this.data.idPrestamo,
            archivo: [], archivoTest: null,
            planes:[],
            calcula: 0,
            montoTotalCuota:this.data.montoTotalCuota,
            asientoContable:this.data.asientoContable,
            estado:this.data.estado
        }
    totalMaximo:any

    constructor( public dialogRef: MatDialogRef<DialogEditPrestamoEjecutivo>,
        private consultaPrestamosService: ConsultaPrestamosService,
        private prestamosService:PrestamosService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog )
                 { }
 
    ngOnInit(): void
         { this.loadData() }
    loadData()
        {
        
        this.data.idUsuario = localStorage.getItem("idUsuario")
        this.data.rol = localStorage.getItem("rol")
        this.data.recarga = false
        this.data.calcula = 0
      
        }

    onDescargarArchivosClick(postulacionId: any)
        {
            let vm = this
     
            vm.consultaPrestamosService.traeArchivos(postulacionId).then
            (
                (archivos: any) =>
                {                
                    archivos.forEach( archivo => {
                        var fileURL=`${environment.urlBlob}/${archivo.url}`    
                        window.open(fileURL,'_blank')                     
                    })  
                   
                }
            )
            .catch
            (
                error =>
                {
                    console.log(error)
                    vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
                }
            )
        }
    onEditarPostulacionClick(): void
    {
        this.data.deshabilitado = false
        this.data.presionaEditar = true
    
    }
    onAprobarPostulacionClick(idPostulacion: any): void
    {
        let vm = this

        const dialogRef = vm.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de aprobar el préstamo?', buttonText: { ok: 'Si', cancel: 'No' } }
        })
        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed)
            {

              Swal.fire({
                allowOutsideClick:false,
                icon:'info',
                text:'Cargando...'
              });
              Swal.showLoading();
              vm.consultaPrestamosService.cambiarEstadoPostulacion(idPostulacion, "DISPONIBLE PARA PAGO",
              ).then
                (
                    () =>
                    {
                        vm.data.recarga = true
                        vm.dialogRef.close()
                        Swal.close();
                        vm.openAlertDialog('La postulación se ha aprobado exitosamente.', 'btn-success')
                    }
                )
                .catch
                (
                    error =>
                    {
                        console.log(error)
                        Swal.close();
                        vm.dialogRef.close()
                        vm.openAlertDialog('Ha ocurrido un error al actualizar la Postulación', 'btn-danger')
                    }
                )
            }
        })
    }
    onRechazarPostulacionClick(idPostulacion: any): void
    {
               
        let vm = this
       
        let dataRechazo: any =
        {
            idPostulacion: idPostulacion,
            tiposRechazo: [],
            tipoRechazo: '',
            email: '',
            nombreCompleto: '',
            nombreProducto: 'PRESTAMO'
        }

        this.consultaPrestamosService.motivoRechazo(4).then
        (
            rechazos => { dataRechazo.tiposRechazo = rechazos
                
              }
        )
        .catch ( error => {console.log(error)
      } )

        const dialogRechazo = this.dialog.open(DialogTipoRechazoPrestamo, { width: '50%', 
            data: dataRechazo });

        dialogRechazo.afterClosed().subscribe( () =>
        {
            vm.data.recarga = true
            vm.dialogRef.close()
        })
    }
    onCancelarClick(): void { this.dialogRef.close() }

    onRechazarClick():void {
        let vm = this
        const dialogRef = this.dialog.open(ConfirmationDialog,
            {
                data: { message: '¿Esta seguro de rechazar ser codeudor?', buttonText: { ok: 'Si', cancel: 'No' } }
            })
            dialogRef.afterClosed().subscribe((confirmed: boolean) =>
            {
                if (confirmed){
                    Swal.fire({
                        allowOutsideClick:false,
                        icon:'info',
                        text:'Cargando...'
                      });
                      Swal.showLoading();
                      
                    this.consultaPrestamosService.rechazarSerCodeudor(this.data.idPrestamo,localStorage.getItem("idUsuario"),false).then
                    (
                        () =>
                        {
                            let vm=this
                         
                            vm.openAlertDialog('Se ha rechazado ser codeudor exitosamente.', 'btn-success')
                            
                            Swal.close();
                        }
                    )
                    .catch((err) => {
                        vm.openAlertDialog('Ocurrió un al rechazar a ser codeudor.', 'btn-success')
                    });
                      vm.dialogRef.close()
                     Swal.close();
                }
            })
        }
    
        
    onAceptarClick():void{
        let vm = this
        let resultado= true
        const dialogRef = this.dialog.open(ConfirmationDialog,
        {
            data: { message: '¿Esta seguro de aprobar ser codeudor?', buttonText: { ok: 'Si', cancel: 'No' } }
        })
        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed){
                Swal.fire({
                    allowOutsideClick:false,
                    icon:'info',
                    text:'Cargando...'
                  });
                  Swal.showLoading();
                  let sizeArchivos=0;
            for(let i = 0; i < 1; i++)
            {
              sizeArchivos +=  this.prestamo.archivo[i].size;
              if(sizeArchivos>25000000 ){
                this.openAlertDialog('Los archivos no deben sobrepasar 25mb en total', 'btn-danger')
                Swal.close();
                return;
              }
              this.prestamo.archivo[i].sizeArchivos
              if(this.prestamo.archivo[i].extension != "application/pdf" && this.prestamo.archivo[i].extension != "image/jpeg" &&
              this.prestamo.archivo[i].extension != "image/jpg" && this.prestamo.archivo[i].extension != "image/png")
              {
                  this.openAlertDialog('El archivo ' + (i + 1) + ' debe ser de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-danger')
  
                  Swal.close();
                  return false
              }
  
            }
                  this.consultaPrestamosService.aprobarSerCodeudor(this.data.idPrestamo,localStorage.getItem("idUsuario"),resultado).then
                  (
                      () =>
                      {
                          let vm=this
                       
                          vm.openAlertDialog('Se ha aprobado ser codeudor exitosamente.', 'btn-success')
                          
                          Swal.close();
                      }
                  )
                  .catch((err) => {
                      vm.openAlertDialog('Ocurrió un al aprobar a ser codeudor.', 'btn-success')
                  });
                    vm.dialogRef.close()
                   Swal.close();
              }
                  vm.dialogRef.close()
                 Swal.close();
            }
         )
    }
    onGuardarClick(form: NgForm){
        let vm = this
        if(this.data.calcula==0){
            vm.openAlertDialog('Para guardar el prestamo primero debe presionar el botón Calcular.', 'btn-danger')                   
            Swal.close();
            return false
        }
        const dialogRef = this.dialog.open(ConfirmationDialog,
            {
                data: { message: '¿Esta seguro de guardar los cambios al Préstamo?', buttonText: { ok: 'Si', cancel: 'No' } }
            })
            dialogRef.afterClosed().subscribe((confirmed: boolean) =>
            {
                if (confirmed){
                    Swal.fire({
                        allowOutsideClick:false,
                        icon:'info',
                        text:'Cargando...'
                      });
                      Swal.showLoading();

                        vm.consultaPrestamosService.guardarEdicion( vm.prestamo,vm.data.idUsuario).then(
                            ()=>{
                                       
                                vm.openAlertDialog('Se ha guardado exitosamente el préstamo.', 'btn-success')
                                
                                Swal.close();
                                this.dialogRef.close();
                            }
                        ).catch ( error =>
                            {
                               // this.prestamo.archivo = [];
                               
                                if(error.status == 403){
                                  this.openAlertDialog('El monto a solicitar debe ser mayor a 0.', 'btn-danger')
                                  Swal.close();
                                }
                                if(error.status == 411){
                                  this.openAlertDialog('El monto a solicitar no debe ser mayor a su tope de deuda', 'btn-danger')
                                  Swal.close();
                                }
                                if(error.status == 417){
                                  this.openAlertDialog('La cantidad de cuotas debe ser mayor a 0.', 'btn-danger')
                                  Swal.close();
                                }
                                if(error.status == 422){
                                  this.openAlertDialog('Debe seleccionar un tipo de préstamo.', 'btn-danger')
                                  Swal.close();
                                }
                                if(error.status == 424){
                                  this.openAlertDialog('El valor de cuota a pagar debe ser mayor a 0.', 'btn-danger')
                                  Swal.close();
                                }
                                if(error.status == 500){
                                  this.openAlertDialog('No se pudo ingresar la solicitud de préstamo. Intente nuevamente.', 'btn-danger')
                                  Swal.close();
                                }
                                if(error.status == 304){
                                    this.openAlertDialog('No se puede modificar el prestamo debido a que una o más cuotas del plan ya fueron gestionadas.', 'btn-danger')
                                    Swal.close();
                                }
                                  
                         
                                console.log(error)
                              } )
                }
            })
                    
    }
	
	 montoMaximoDisponible(){
        this.prestamosService.traeMontoTotalDisponible(this.data.idUsuario).then(
            response =>
              {
                this.totalMaximo=response;
                this.prestamo.montoSolicitado=response;
              }
          ).catch(error =>{
            console.log(error);
            this.totalMaximo = 0;
          });
    }
    calcularPlanPago(){
        let vm = this
      
        vm.prestamosService.calcularPlanPago(vm.prestamo.montoSolicitado,vm.prestamo.cantidadCuotas).
        then(
            (planes : any)=>
              {
                this.data.calcula=this.data.calcula+1;
                this.data.montoTotalCuota = planes[0].montoTotalCuota;
                this.data.fechaPrimerPago = planes[0].fechaPago;
                this.prestamo.montoTotalCuota = planes[0].montoTotalCuota;
                this.prestamo.montoCuota = planes[0].montoCuota
                this.prestamo.fechaPrimerPago = planes[0].fechaPago;
                this.prestamo.planes = planes;
            }
          )
          .catch ( error =>
            {
                console.log(error)
                Swal.close();
                this.openAlertDialog('No se pudo calcular el plan de pago. Intente nuevamente.', 'btn-danger')
            } )
        }
    seleccionaArchivo(event: any)
    {
        if(event.target.files.length > 0)
        {
            console.log(event.target.files[0].type)
             event.target.files[0].type

            let vm = this
            let reader = new FileReader()

            reader.readAsDataURL(event.target.files[0])

            reader.onload = function() {
                reader.result

                console.log(reader.result)
            }
        }
    }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
    openDialogAnular(idPostulacion: any, rut: any)
    {
        const dialogRef = this.dialog.open(ConfirmationDialog,
        {
            data: { message: '¿Esta seguro de anular la solicitud de Préstamo?', buttonText: { ok: 'Si', cancel: 'No' } }
        })

        dialogRef.afterClosed().subscribe( (confirmed: boolean) =>
        {
            if (confirmed)
            {

              Swal.fire({
                allowOutsideClick:false,
                icon:'info',
                text:'Cargando...'
              });
              Swal.showLoading();
                let vm = this
            
                this.consultaPrestamosService.cambiarEstadoPostulacion(idPostulacion, "ANULADA").then
                (
                    () =>
                    {
                        vm.openAlertDialog('La postulación se ha anulado exitosamente.', 'btn-success')
                        Swal.close();
                        this.dialogRef.close()                      
                    }
                )
                .catch
                (
                    error =>
                    {

                        Swal.close();
                        console.log(error)
                        vm.openAlertDialog('La postulación no se ha podido anular.', 'btn-danger')
                    }
                )

            }
        })
    }

    onGuardaryAprobarClick(form:NgForm){
        let vm = this     
       false;
        vm.consultaPrestamosService.guardarEdicion( vm.prestamo,vm.data.idUsuario).then(
            ()=>{
                vm.onAprobarPostulacionClick(vm.prestamo.idPostulacion);
            }
        ).catch ( error =>
            {
               
               
                if(error.status == 403){
                  this.openAlertDialog('El monto a solicitar debe ser mayor a 0.', 'btn-danger')
                  Swal.close();
                }
                if(error.status == 411){
                  this.openAlertDialog('El monto a solicitar no debe ser mayor a su tope de deuda.', 'btn-danger')
                  Swal.close();
                }
                if(error.status == 417){
                  this.openAlertDialog('La cantidad de cuotas debe ser mayor a 0.', 'btn-danger')
                  Swal.close();
                }
                if(error.status == 422){
                  this.openAlertDialog('Debe seleccionar un tipo de préstamo.', 'btn-danger')
                  Swal.close();
                }
                if(error.status == 424){
                  this.openAlertDialog('El valor de cuota a pagar debe ser mayor a 0.', 'btn-danger')
                  Swal.close();
                }
                if(error.status == 500){
                  this.openAlertDialog('No se pudo guardar la solicitud de préstamo. Intente nuevamente.', 'btn-danger')
                  Swal.close();
                }
         
                console.log(error)
              } )
    }
}
